export { PromoCardHorizontalComponent } from "./PromoCardHorizontal.builder";
